import StateItem from './StateItem'
function States({ states }) {
  return (
    <div id="states" className="pt-[32px] custom-gradient-state flex flex-col items-center relative bottom-[260px] mt-[30px] px-[24px]">
      <h2 className='ml-[20px] font-noto-sans  font-[600] text-[32px] text-greyTitleBase900'>Find jobs in your local area</h2>
      <div className='grid grid-cols-2 justify-between gap-x-[17px] gap-y-[69px] pt-[32px]'>
        {states.map((state) => {
          return <StateItem state={state} key={state.id} />
        })}
      </div>
    </div>
  )
}

export default States
